<template>
  <div>
    <ra-card>
      <template slot="header">
        <p>Organisation Information</p>
      </template>
      <template slot="content">
        <el-form :model="form" label-position="top" ref="form">
          <el-row type="flex" :gutter="20">
            <el-col :xs="24" :sm="8" :md="8">
              <el-form-item
                label="Name"
                prop="name"
                :rules="validateField('Name')"
              >
                <el-input v-model="form.name" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item
                label="CAC RC No"
                prop="identification_number"
                :rules="validateField('CAC Number')"
              >
                <el-input v-model="form.identification_number" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="10" :md="10">
              <el-form-item label="Website">
                <el-input
                  v-model="form.website"
                  placeholder="https://www.mycompany.com"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="Address">
                <el-input v-model="form.address" type="textarea" rows="5" />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="is-flex is-justify-end">
            <el-button
              type="primary"
              :disabled="!update"
              :loading="updating"
              @click="updateOrganisation"
              >Update</el-button
            >
          </div>
        </el-form>
      </template>
    </ra-card>
    <ra-card v-if="!isOrganisationActive">
      <template slot="header">
        <p>Organisation Verification</p>
      </template>
      <template slot="content">
        <organisation-verification />
      </template>
    </ra-card>
    <ra-card v-if="isOrganisationOwner()">
      <template slot="header">
        <p>Danger Zone</p>
      </template>
      <template slot="content">
        <organisation-actions />
      </template>
    </ra-card>
  </div>
</template>

<script>
import { isOrganisationActive } from "@/lib/utils";
import apiConstants from "@/apiConstants";
import * as actions from "@/store/action-types";
import OrganisationVerification from "@/components/Organisation/OrganisationVerification.vue";
import OrganisationActions from "@/components/Organisation/Actions/OrganisationActions.vue";

export default {
  name: "OrganisationSettings",
  components: { OrganisationActions, OrganisationVerification },
  props: {
    organisation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOrganisationActive: isOrganisationActive(),
      form: {
        name: "",
        address: "",
        website: "",
        identification_system_id: apiConstants.IDENTIFICATION_SYSTEM.CORPORATE,
        identification_number: ""
      },
      update: false,
      updating: false
    };
  },
  watch: {
    form: {
      deep: true,
      handler() {
        const keys = ["name", "address", "website", "identification_number"];
        let res = false;
        keys.forEach(key => {
          res = this.organisation[key] !== this.form[key];
        });
        this.update = res;
      }
    }
  },
  created() {
    const { name, address, website, identification_number } = this.organisation;
    this.form.name = name;
    this.form.address = address;
    this.form.website = website;
    this.form.identification_number = identification_number;
  },
  methods: {
    updateOrganisation() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.updating = true;
        this.$http
          .post(`organisations/${this.organisation.id}`, {
            body: this.form,
            method: "PUT"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
            } else {
              const organisation = this.$store.getters.organisation;
              this.$store.dispatch(actions.ORGANISATION, {
                ...organisation,
                summary: {
                  ...resData,
                  status: {
                    id: resData.status_id,
                    label:
                      resData.status_id &&
                      apiConstants.GLOBAL_STATUS_LABEL[resData.status_id]
                  }
                }
              });
              this.notification(
                "Completed",
                "Organisation verified successfully",
                "success"
              );
              this.updating = false;
              this.update = false;
            }
          })
          .catch(() => {
            this.notification("Error", "An unknown error occurred", "danger");
            this.updating = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.9rem;
  opacity: 1 !important;
  margin-bottom: 20px;
}
</style>
